<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>工程师服务过程管理【工单明细】</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div name="table-list" class="table-layout" v-if="paramMap != null">
            <swb-easy-report-table :confKey="confKey" :configAuto="configAuto" :reportName="reportName" :reportCode="reportCode" :paramMap="paramMap" :paramKeys="paramKeys" :defaultSortItems="defaultSortItems" :querySortItems="querySortItems" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="queryData" :domHeight="domHeight"></swb-easy-report-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import easyReportApi from '../../api/easyReport'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'engineer-servc-process-detail',
        path: '/engineer/servc/process/detail',
        desc: '工程师服务过程管理【工单明细】',
        helpArticleCode: 'servicer-engi-servc-process-detail',
        data: function () {
            return {
                confKey: 'engineer-servc-process-detail',
                configAuto: true,
                reportCode: "servicer_engineer_servc_process_detail",
                reportName: "工程师服务过程管理【工单明细】",
                domHeight: 'auto',
                //
                paramMap: null,
                paramKeys: [],
                hideParamKeys: ["servicerId", "cxtMerchantId", "cxtMerchantIdX"],
                defaultSortItems: ["createTime:desc", "startOffDate:desc", "toDoorTime:desc", "finishTime:desc"],
                querySortItems: [],
                queryData: false,
            }
        },
        created: function () {
            let paramMap = {
                servicerId: 259,
            };
            //
            this.queryData = this.$route.query.queryData || false;
            //
            let dataJson = this.$route.query.dataJson || null;
            if(!Utils.isNoB(dataJson)) {
                let colName = this.$route.query.colName || null;
                if(!Utils.isNoB(colName)) {
                    // 2,未出发|3,服务未完成|4,未验收|1,工单总数
                    dataJson.detailType = colName == "repairQuantity" ? 1 : colName == "readyStartQuantity" ? 2 : colName == "inServiceQuantity" ? 3 : colName == "completedQuantity" ? 4 : null;
                }
                let paramKeys = Object.keys(dataJson) || [];
                //
                this.paramMap = Utils.merge({}, dataJson);
                this.paramKeys = Utils.merge({}, paramKeys);
            } else {
                this.paramMap = Utils.merge({}, paramMap);
            }
            //
            this.setQuerySortItems();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="table-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"]'));
            domSizeWatcher.start(500);
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            setQuerySortItems: function () {
                let querySortItems = [];
                let sortField = {
                    label: "创建时间",
                    code: "createTime",
                    order: "desc",
                    enabled: true
                };
                querySortItems.push(sortField);
                sortField = {
                    label: "出发时间",
                    code: "startOffDate",
                    order: "desc",
                    enabled: true
                };
                querySortItems.push(sortField);
                sortField = {
                    label: "到达时间",
                    code: "toDoorTime",
                    order: "desc",
                    enabled: true
                };
                querySortItems.push(sortField);
                sortField = {
                    label: "完成时间",
                    code: "finishTime",
                    order: "desc",
                    enabled: true
                };
                querySortItems.push(sortField);
                this.querySortItems = Utils.merge([], querySortItems);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/EngineerServcProcessDetail.vue